<template>
  <section
    id="support"
    class="co-bg-striped px-5 py-20"
  >
    <div class="co-container-lg text-center">
      <h2 class="co-heading-2-caption">
        挫折させない学習サポート
      </h2>
      <div class="mb-12 text-center text-co-gray-600">
        現役のプロがあなたのメンターとなり学習時の疑問や悩みを解決へ導きます
      </div>
      <div class="flex flex-col gap-12 md:flex-row">
        <div class="w-full md:w-1/3">
          <img
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentoring/ill-mentor-support-mentoring.svg"
            width="368"
            height="207"
            class="mb-4 w-full"
            loading="lazy"
            alt="マンツーマンメンタリング"
          >
          <h3 class="co-display-10 mb-2 font-bold leading-normal">
            マンツーマンメンタリング
          </h3>
          <div class="text-center text-co-gray-600">
            1回30分のビデオチャットで、<br>質問や相談など現役のプロがお答えします。
          </div>
        </div>
        <div class="w-full md:w-1/3">
          <img
            src="~/assets/images/Te/TeCommon/MentorSupport/ChatSupport/ill-mentor-support-chat.svg"
            width="368"
            height="207"
            class="mb-4 w-full"
            loading="lazy"
            alt="チャットサポート"
          >
          <h3 class="co-display-10 mb-2 font-bold leading-normal">
            毎日のチャットサポート
          </h3>
          <div class="text-co-gray-600">
            毎日オンラインで現役のプロが待機してるので<br>疑問点を聞けばチャットですぐ回答がもらえます。
          </div>
        </div>
        <div class="w-full md:w-1/3">
          <img
            src="~/assets/images/Te/TeCommon/MentorSupport/IssueReview/ill-mentor-support-review.svg"
            width="376"
            height="211"
            class="mb-5 w-full"
            loading="lazy"
            alt="回数無制限の課題レビュー"
          >
          <h3 class="co-display-10 mb-2 font-bold leading-normal">
            回数無制限の課題レビュー
          </h3>
          <div class="text-co-gray-600">
            学習中に出される課題において、正しく理解できるまで何度でもレビューを受けることができます。
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
